import React from 'react';
import styled from 'styled-components';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import MergePair from './MergePair';
import { useContactsContext } from '../contexts/ContactsContext';

interface Props {
  onClickMergeSuggestion: (mergeSuggestionId: string) => void;
}

export default function Merges(props: Props) {
  const contactContext = useContactsContext();
  const lcm = contactContext.LCM;

  if (lcm === undefined) {
    return <></>;
  }

  const keys: string[] = Array.from(lcm.keys());
  if (keys.length == 0) {
    return <></>;
  }

  return (
    <ForReviewContent>
      {keys.map((key, index) => {
        return (
          <Row key={index}>
            <Col>
              <MergePair
                key={key} mergeSuggestionId={key} contacts={lcm.get(key)}
                onClickMergeSuggestion={props.onClickMergeSuggestion}/>
            </Col>
          </Row>
        );
      })}
    </ForReviewContent>
  );
}

const ForReviewContent = styled.div`
  clear: both;
  padding-top: 24px;
  padding-bottom: 24px;
`;
